import { KameleoonVariationType } from '@kameleoon/javascript-sdk';

const setActiveABFeatures = (features: Map<string, KameleoonVariationType>): void => {
    window.activeFeatures = features
}   

export default setActiveABFeatures